import React from 'react';
import { useDrag } from 'react-dnd';
import { CodifierElement, CodifierElementIconEnum } from '@lms-elements/atomic';

import { MINIMIZED_DESC, MINIMIZED_TITLE } from './CONSTANTS';
import { IMinimizedAudioMaterialProps, MIN_AUDIO_MATERIAL_DRAG_TYPE } from './MinimizedAudioMaterial.types';

export const MinimizedAudioMaterial: React.FC<IMinimizedAudioMaterialProps> = React.memo(
    ({ onDragEnd, disabled = false }) => {
        const [{ isDragging }, drag] = useDrag({
            type: MIN_AUDIO_MATERIAL_DRAG_TYPE,
            item: () => ({ name: 'MEDIA_MATERIAL' }),
            end: (item, monitor) => {
                const dropResult = monitor.getDropResult();
                if (item && dropResult && onDragEnd) {
                    onDragEnd();
                }
            },
            collect: (monitor) => ({ isDragging: monitor.isDragging() }),
        });

        return (
            <CodifierElement
                title={MINIMIZED_TITLE}
                description={MINIMIZED_DESC}
                icon={CodifierElementIconEnum.audio}
                dragging={isDragging}
                dragRef={drag}
                disabled={disabled}
            />
        );
    },
);
